export default {
  id: "kayzen",
  name: "Kayzen",
  color: "#4ADE80",
  platformIds: ["kayzen"],

  target: {
    supported: false,
    hint: "Coming soon",
    platformId: "kayzen",
    zipSuffix: "Kayzen",
  },
};
